import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventService } from 'src/app/services/event.service';
import Event from 'src/app/interfaces/Event';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import User from 'src/app/interfaces/User';
import { AnalyticsService } from 'src/app/services/analytics.service';

declare var addToCalendar: any;

@Component({
  selector: 'app-event-single',
  templateUrl: './events-single.component.html',
  styleUrls: ['./events-single.component.scss'],
})
export class EventsSingleComponent implements OnInit, OnDestroy {
  event$;
  event;
  members;
  dateStr;
  timeStr;
  moment = moment;
  subscriptions: Subscription = new Subscription();
  currentUser: User;

  constructor(
    private eventService: EventService,
    private route: ActivatedRoute,
    private userService: UserService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('event_detail_view');
    this.event$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.eventService.getCurrentEvent(params.get('id')))
    );
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
          if (!this.currentUser.events) {
            this.currentUser.events = [];
          }
        }
      })
    );
    this.event$.subscribe((e) => {
      this.event = e[0];
      this.dateStr = this.formatDateStr(this.event.dateTime.startDate, this.event.dateTime.endDate);
      this.timeStr = this.formatTimeStr(this.event.dateTime.startTime, this.event.dateTime.endTime);
      this.addToCal();

      this.eventService.getEventMembers(this.event.id).subscribe((m) => {
        this.members = m;
      });
    });
  }
  
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  addEventToProfile() {
    this.analyticsService.event('event_detail_add_click');
    if (this.currentUser.events.indexOf(this.event.id) === -1) {
      this.currentUser.events.push(this.event.id);
      this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
        this.eventService.getEventMembers(this.event.id).subscribe((m) => {
          this.members = m;
        });
      });
    }
  }
  removeEventFromProfile() {
    if (this.currentUser.events.indexOf(this.event.id) !== -1) {
      this.currentUser.events.splice(this.currentUser.events.indexOf(this.event.id));
      this.userService.saveUser(this.currentUser.uid, this.currentUser).then(() => {
        this.eventService.getEventMembers(this.event.id).subscribe((m) => {
          this.members = m;
        });
      });
    }
  }

  formatDateStr(start, end) {
    if (start === end || end === null) {
      // same date
      return moment(start).format('D MMMM YYYY');
    } else if (moment(start).month() === moment(end).month()) {
      // same month different day
      return moment(start).date() + ' - ' + moment(end).format('D MMMM YYYY');
    } else if (moment(start).year() === moment(end).year()) {
      // same year different month
      return moment(start).format('D MMM') + ' - ' + moment(end).format('D MMM YYYY');
    } else {
      // different year
      return moment(start).format('D MMM YYYY') + ' - ' + moment(end).format('D MMM YYYY');
    }
  }

  formatTimeStr(start, end) {
    let sStr =
      (parseInt(start) > 12 ? parseInt(start) - 12 : parseInt(start)) + // hour
      start.substring(start.length - 3) + // minutes
      (parseInt(start) > 12 ? 'pm' : 'am'); // am/pm
    let eStr = end // if end exists
      ? (parseInt(end) > 12 ? parseInt(end) - 12 : parseInt(end)) + // hour
        end.substring(end.length - 3) + // minutes
        (parseInt(end) > 12 ? 'pm' : 'am') // am/pm
      : null;

    return sStr + (end ? ' - ' + eStr : '');
  }

  combineDate(d, t) {
    return `${d}T${t}`;
  }

  addToCal() {
    const start = this.combineDate(this.event.dateTime.startDate, this.event.dateTime.startTime);
    const end = this.combineDate(this.event.dateTime.endDate, this.event.dateTime.endTime);
    const cal = addToCalendar({
      options: {
        class: 'add-cal',
        id: 'single-event-add-to-cal',
      },
      data: {
        title: this.event.title,
        start: new Date(start),
        end: new Date(end),
        address: this.event.location.street,
      },
    });
    setTimeout(() => {
      document.getElementById('addtocal').appendChild(cal);
    }, 1000);
  }
}
